import * as React from 'react';
import Box from '@mui/material/Box';
import { BarChart } from '@mui/x-charts/BarChart';


const colors = ['#D6B981', '#F4E8D1', '#F4E8B1', '#E8C48F', '#D4A76A'];

const BarCharts = ({ profit = 0, dailyBookings = [], title = "Statistiken" }) => {

  const bookingDates = dailyBookings.map(item => {
    const date = new Date(item._id);
    return date.toLocaleDateString('de-DE', {
      day: 'numeric',
      month: 'short'
    });
  });

  const bookingCounts = dailyBookings.map(item => item.count);
  const allDates = ['Gewinn', ...bookingDates];
  const allValues = [profit, ...bookingCounts];

  return (
    <Box
      border={2}
      borderColor="#CD9D4126"
      borderRadius="12px"
      bgcolor="white"
      px={1}
      py={2}
      pt={5}
      height="330px"
    >
      <BarChart
        borderRadius={12}
        width={700}
        height={260}
        xAxis={[
          {
            scaleType: 'band',
            data: allDates,
            label: 'Statistiken',
            labelStyle: { fill: '#A67C00', fontSize: 12 },
          }
        ]}
        yAxis={[
          {
            label: 'Wert',
            labelStyle: { fill: '#A67C00', fontSize: 12 },
          }
        ]}
        series={[
          {
            data: allValues,
            color: colors[0],
            label: 'Werte',
          }
        ]}
        slotProps={{
          axisBottom: {
            tickLabelStyle: { fill: '#A67C00' },
            lineStyle: { stroke: '#A67C00' },
            tickLineStyle: { stroke: '#A67C00' },
          },
          axisLeft: {
            tickLabelStyle: { fill: '#A67C00' },
            lineStyle: { stroke: '#A67C00' },
            tickLineStyle: { stroke: '#A67C00' },
          },
        }}
      />
    </Box>
  );
};

export default BarCharts;
